/**
 * @file components/biz/useSubmit
 * @author sunwen05
 */

import _ from 'lodash';
import {useState, useCallback, useRef} from 'react';
import {FormInstance} from 'acud/lib/form';

import {getGlobalError, message} from '../../../utils/bizUtil';
import {createPayload} from '../../../components/biz/common/helper';

import {SubmitAction} from './interface';

export default (
    form: FormInstance,
    actions: any,
    submitAction: SubmitAction,
    fetchData?: any,
    customFunctions?: any,
    onSuccess?: any
) => {
    const {
        submitFormAction,
        payload,
        $onSubmitRequest,
        $onSubmitResponse,
        $onSubmitError,
        $toastSuccessMessage,
        $toastSuccessMessageFn,
        $toastErrorMessage,
        $toastErrorMessageFn
    } = (submitAction || {});

    const hooksRef = useRef<any>(null);
    hooksRef.current = {
        $onSubmitRequest,
        $onSubmitResponse,
        $onSubmitError
    };

    // state - 提交状态
    const [isSubmiting, setSubmiting] = useState(false);

    const actualSubmit = useCallback(async (values?: any) => {
        try {
            // 是否loading
            if (isSubmiting) {
                return Promise.reject();
            }
            setSubmiting(true);
            // values与originFormData进行merge
            const params = {...createPayload(fetchData, payload), ...values};
            // request
            const formPayload = _.isFunction(hooksRef.current.$onSubmitRequest)
                ? hooksRef.current.$onSubmitRequest(params) || params
                : params;

            const data = await actions[submitFormAction](formPayload);

            // response
            _.isFunction(hooksRef.current.$onSubmitResponse) && hooksRef.current.$onSubmitResponse(data);
            if (typeof $toastSuccessMessageFn === 'function') {
                $toastSuccessMessageFn(data);
            }
            else {
                const successMessage = $toastSuccessMessage || '提交成功';
                message('success', successMessage);
            }


            setSubmiting(false);
            onSuccess && onSuccess(data);
        }
        catch (error) {
            setSubmiting(false);
            _.isFunction(hooksRef.current.$onSubmitError) && hooksRef.current.$onSubmitError(error);
            if (typeof $toastErrorMessageFn === 'function') {
                $toastErrorMessageFn(error);
            }
            else {
                const errorMsg = getGlobalError(error) || $toastErrorMessage;
                errorMsg && message('error', errorMsg);
            }
        }
    }, [
        isSubmiting,
        fetchData,
        actions,
        onSuccess,
        submitFormAction,
        payload,
        $toastSuccessMessage,
        $toastErrorMessage
    ]);

    const doSubmit = useCallback(async values => {
        if (customFunctions.doSubmit) {
            return customFunctions.doSubmit(values);
        }
        if (_.isEmpty(values)) {
            values = await form.validateFields();
        }

        return actualSubmit(values);
    }, [actualSubmit, customFunctions, form]);

    return {
        isSubmiting,
        setSubmiting,
        doSubmit,
        actualSubmit
    };
};
